import help from "@/components/help/store/help";
import replaceDictionaryStore from "@/components/ReplaceDictionaries/store/replace_dictionary_store";
import languageDictionaryStore from "@/components/LanguageDictionaries/store/languageDictionaryStore";;
import synonymDictionaryStore from "@/components/SynonymDictionaries/store/synonymDictionaryStore";
import powertranslate from "@/store/powertranslate"

export default {
	state: {},
	modules: {
		help,
		replaceDictionaryStore,
		synonymDictionaryStore,
		languageDictionaryStore,
		powertranslate,
	}
};
